import { CALL_API } from '../middleware/api';

// ACTIONS

export const MESSAGES_FETCH_REQUEST = 'accounts/MESSAGES_FETCH_REQUEST';
export const MESSAGES_FETCH_SUCCESS = 'accounts/MESSAGES_FETCHED_SUCCESS';
export const MESSAGES_FETCH_ERROR = 'accounts/MESSAGES_FETCHED_ERROR';

export const MESSAGES_MODIFY_REQUEST = 'accounts/MESSAGES_MODIFY_REQUEST';
export const MESSAGES_MODIFY_SUCCESS = 'accounts/MESSAGES_MODIFY_SUCCESS';
export const MESSAGES_MODIFY_ERROR = 'accounts/MESSAGES_MODIFY_ERROR';

export const EVENT_ACTION_TEXT_FETCH_REQUEST = 'accounts/EVENT_ACTION_TEXT_FETCH_REQUEST';
export const EVENT_ACTION_TEXT_FETCH_SUCCESS = 'accounts/EVENT_ACTION_TEXT_FETCH_SUCCESS';
export const EVENT_ACTION_TEXT_FETCH_ERROR = 'accounts/EVENT_ACTION_TEXT_FETCH_ERROR';

export const EVENT_ACTION_TEXT_MODIFY_REQUEST = 'accounts/EVENT_ACTION_TEXT_MODIFY_REQUEST';
export const EVENT_ACTION_TEXT_MODIFY_SUCCESS = 'accounts/EVENT_ACTION_TEXT_MODIFY_SUCCESS';
export const EVENT_ACTION_TEXT_MODIFY_ERROR = 'accounts/EVENT_ACTION_TEXT_MODIFY_ERROR';

// REDUCER
export default function reducer(
  state = {
    paketboxMessages: null,
    paketboxModifySuccess: null,
    termsMessages: null,
    termsModifySuccess: null,
    privacyPolicy: null,
    privacyPolicyModifySuccess: null,
    otherModifySuccess: null,
    otherMessages: null,
    fetching: false,
    fetched: false,
    modified: false,
    error: null,
    eventActionText: null,
  },
  action
) {
  switch (action.type) {
    case MESSAGES_FETCH_REQUEST:
      return {
        ...state,
        fetching: true,
      };

    case EVENT_ACTION_TEXT_FETCH_REQUEST:
      return {
        ...state,
        fetching: true,
      };

    case MESSAGES_FETCH_SUCCESS: {
      const sorted = action.payload.sort((a, b) => {
        if (a.type < b.type) {
          return -1;
        }
        if (a.type > b.type) {
          return 1;
        }
        if (a.protocol < b.protocol) {
          return -1;
        }
        if (a.protocol > b.protocol) {
          return 1;
        }
        return 0;
      });

      const newState = {
        fetching: false,
        fetched: true,
      };

      if (action.group === 'PAKETBOX') {
        newState.paketboxMessages = sorted;
      } else if (action.group === 'TERMS_AND_CONDITIONS') {
        newState.termsMessages = sorted;
      } else if (action.group === 'PRIVACY_POLICY') {
        newState.privacyPolicy = sorted;
      } else {
        newState.otherMessages = sorted;
      }

      return Object.assign({}, state, newState);
    }

    case EVENT_ACTION_TEXT_FETCH_SUCCESS:
      return {
        ...state,
        fetching: false,
        fetched: true,
        eventActionText: action.payload.data,
      };

    case MESSAGES_MODIFY_REQUEST: {
      const newState = {};
      if (action.group === 'PAKETBOX') {
        newState.paketboxModifySuccess = null;
      } else if (action.group === 'TERMS_AND_CONDITIONS') {
        newState.termsModifySuccess = null;
      } else if (action.group === 'PRIVACY_POLICY') {
        newState.privacyPolicy = null;
      } else {
        newState.otherModifySuccess = null;
      }

      return Object.assign({}, state, newState);
    }

    case EVENT_ACTION_TEXT_MODIFY_SUCCESS:

    case MESSAGES_MODIFY_SUCCESS: {
      const newState = {};

      if (action.group === 'PAKETBOX') {
        newState.paketboxModifySuccess = true;
      } else if (action.group === 'TERMS_AND_CONDITIONS') {
        newState.termsModifySuccess = null;
      } else if (action.group === 'PRIVACY_POLICY') {
        newState.privacyPolicy = null;
      } else {
        newState.otherModifySuccess = true;
      }

      return Object.assign({}, state, newState);
    }

    case MESSAGES_FETCH_ERROR:
      return {
        ...state,
        fetching: false,
        error: action.payload,
      };

    case EVENT_ACTION_TEXT_FETCH_ERROR:
      return {
        ...state,
        fetching: false,
        error: action.payload,
      };

    case EVENT_ACTION_TEXT_MODIFY_ERROR:
      return {
        ...state,
        fetching: false,
        error: action.payload,
      };
  }

  return state;
}

// Operations
export function fetchMessages(type = 'PAKETBOX') {
  return {
    [CALL_API]: {
      types: [MESSAGES_FETCH_REQUEST, MESSAGES_FETCH_SUCCESS, MESSAGES_FETCH_ERROR],
      promise: httpClient => httpClient.get(`/message/${type}`),
    },
    group: type,
  };
}

export function modifyMessages(messages, group) {
  const data = {
    messages,
  };

  const groupFormatted =
    group.charAt(0).toUpperCase() +
    group
      .slice(1)
      .toLowerCase()
      .replace(/_/g, ' ');

  return {
    [CALL_API]: {
      types: [MESSAGES_MODIFY_REQUEST, MESSAGES_MODIFY_SUCCESS, MESSAGES_MODIFY_ERROR],
      promise: httpClient => httpClient.post('/message', data),
      successMessage: `Messages (${groupFormatted}) successfully modified`,
    },
    group,
  };
}

export function fetchEventActionTexts() {
  return {
    [CALL_API]: {
      types: [
        EVENT_ACTION_TEXT_FETCH_REQUEST,
        EVENT_ACTION_TEXT_FETCH_SUCCESS,
        EVENT_ACTION_TEXT_FETCH_ERROR,
      ],
      promise: httpClient => httpClient.post('/eventActionText'),
    },
  };
}

export function modifyEventActionTexts(eventActionTexts) {
  return {
    [CALL_API]: {
      types: [
        EVENT_ACTION_TEXT_MODIFY_REQUEST,
        EVENT_ACTION_TEXT_MODIFY_SUCCESS,
        EVENT_ACTION_TEXT_MODIFY_ERROR,
      ],
      promise: (httpClient) => {
        const promises = eventActionTexts.map(eventActionText =>
          httpClient.post('/eventActionText/modify', eventActionText)
        );
        return Promise.all(promises);
      },
      successMessage: 'Action text successfully modified',
    },
  };
}



// WEBPACK FOOTER //
// ./src/redux/modules/messages.js